import { FC } from "react";
import { useI18n } from "../../../hooks/useTranslations";
import { useCostTypeCategoriesApi } from "../../../http/costTypeCategories/api";
import HistoryDialog from "../../ui/HistoryDialog";
import VersionDialog from "../../ui/VersionDialog";

interface CostTypeCategoryHistoryDialogProps {
  itemToShowVersionsId: string;
  itemVersionToShowVersions: number;
  onClose: () => void;
}
const CostTypeCategoryHistoryDialog: FC<CostTypeCategoryHistoryDialogProps> = ({
  itemToShowVersionsId,
  itemVersionToShowVersions,
  onClose,
}) => {
  const i18n = useI18n();
  const costTypeCategoriesApi = useCostTypeCategoriesApi();

  return (
    <HistoryDialog
      title={i18n.t.costTypeCategories.versions}
      lastVersion={itemVersionToShowVersions}
      entityId={itemToShowVersionsId}
      getEntityVersionHook={costTypeCategoriesApi.getAdminCostTypeCategoryVersion}
      getHistory={costTypeCategoriesApi.getAdminCostTypeCategoryHistory}
      onClose={onClose}
      renderForm={(headers, dataVersion) => (
        <>
          <VersionDialog.Table headers={headers}>
            <tr>
              <VersionDialog.Field
                label={i18n.t.common.name}
                value={dataVersion.current?.name}
                edited={dataVersion.next.name}
              />
            </tr>
          </VersionDialog.Table>
        </>
      )}
    />
  );
};

export default CostTypeCategoryHistoryDialog;
